import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { BlockedByFeature, BlockedByFeatureType } from '../../../featureToggles/features/utils';
import { RootState } from '../../rootReducer';
import { ISubscriptionPrices } from './interfaces';

export const selectSubscriptionPrices = (state: RootState): BlockedByFeatureType | ISubscriptionPrices | undefined => {
  if (!isFeatureEnabled(Features.PromotionalCodes)) {
    return BlockedByFeature;
  }
  return state.upgradeAccount.subscriptionPrices.prices;
};